/**
 * @description: toast 提示框
 * @param {String} text 提示文本
 * @param {String} success 是否展示成果icon
 * @param {String} duration 持续时间
 */
class SimpleToast extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
  }
  createDiv() {
    const div = document.createElement('div')
    if (this.success) {
      div.innerHTML = this.getSuccessIcon()
      div.className = 'simple-toast icon-toast'
      div.appendChild(document.createTextNode(this.text))
    } else {
      div.className = 'simple-toast'
      div.innerText = this.text
    }
    return div
  }
  connectedCallback() {
    this.text = this.getAttribute('text') || ''
    this.success = this.getAttribute('success') == 'true' ? true : false
    this.duration = this.getAttribute('duration') || 2000
    const style = document.createElement('style')
    style.textContent = `
      .simple-toast {
        position: fixed;
        z-index: 999;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.80);
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07);
        color: #fff;
        font-size: 14px;
        padding: 12px;
      }
      .icon-toast {
        display:flex;
        align-items:center;
        justify-content:center;
      }
    `
    this.shadowRoot.appendChild(style)
    const div = this.createDiv()
    this.shadowRoot.appendChild(div)
    // 保证toast绘制成功后再计时
    requestAnimationFrame(() => {
      this.clearTimer = setTimeout(() => {
        this.remove()
        console.log('toast end:', Date.now())
      }, this.duration)
    })
  }
  remove() {
    this.parentNode.removeChild(this)
  }
  disconnectedCallback() {
    if (this.clearTimer) {
      clearTimeout(this.clearTimer)
      this.clearTimer = null
    }
  }
  getSuccessIcon() {
    return `
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" style="margin-right:8px;">
      <g clip-path="url(#clip0_1148_7695)">
        <path d="M16.1763 0H0.17627V16H16.1763V0Z" fill="white" fill-opacity="0.01"/>
        <path d="M14.5096 3.66675L5.80123 12.3334L1.8429 8.39402" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_1148_7695">
          <rect width="16" height="16" fill="white" transform="translate(0.17627)"/>
        </clipPath>
      </defs>
    </svg>
  `
  }
}
customElements.define('hxz-simple-toast', SimpleToast)

window.showToast = function showToast(
  text,
  options = { success: false, duration: 2000, shouldReturn: false }
) {
  const toast = document.createElement('hxz-simple-toast')
  toast.setAttribute('text', text)
  toast.setAttribute('success', options.success || false)
  if (options.duration) {
    toast.setAttribute('duration', options.duration)
  }
  if (options.shouldReturn) {
    return toast
  }
  document.body.appendChild(toast)
}
/**
 * @description: 模态框
 * @param {string} mask-close 点击模态框外部关闭,默认为true
 * @return {Function} modal-close 监听事件关闭本身
 */
class SimpleModal extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
  }
  modalClose() {
    this.modal = this.shadowRoot.querySelector('.simple-modal-content')
    this.modal.addEventListener('click', e => {
      if (e.target === this.modal) {
        if (this.destroyOnClose == 'true') {
          this.destroy()
        } else {
          this.close()
        }
      }
    })
  }
  connectedCallback() {
    const modalClose = this.getAttribute('mask-close') || 'true'
    this.destroyOnClose = this.getAttribute('destroy-on-close') || 'false'
    this.shadowRoot.innerHTML = `
      <style>
        .simple-modal {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 998;
          width: 100%;
          height: 100%;
          background: rgba(0, 18, 25, 0.6);
        }
        .modal-hidden {
          display:none;
        }
        .simple-modal-content {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      </style>
      <div class="simple-modal modal-hidden">
        <div class="simple-modal-content">
          <slot></slot>
        </div>
      </div>
    `
    if (modalClose == 'true') {
      this.modalClose()
    }
    this.bindingEvent()
    this.setAttribute('created', true)
  }
  bindingEvent() {
    // 监听关闭事件
    this.addEventListener('modal-close', e => {
      e.stopPropagation()
      this.close()
    })
    // 监听销毁事件
    this.addEventListener('modal-destroy', e => {
      e.stopPropagation()
      this.destroy()
    })
  }
  destroy() {
    document.body.style.removeProperty('overflow')
    console.log('destroy')
    this.parentNode.removeChild(this)
  }
  close() {
    document.body.style.removeProperty('overflow')
    this.shadowRoot.querySelector('.simple-modal').classList.add('modal-hidden')
  }
  open() {
    document.body.style.overflow = 'hidden'
    this.shadowRoot
      .querySelector('.simple-modal')
      .classList.remove('modal-hidden')
  }
}
customElements.define('hxz-simple-modal', SimpleModal)

/**
 * 根据图片地址，生成多种尺寸的图片链接
 * @class HxzImage
 * @param {string} src 图片链接
 * @param {boolean} full-screen 是否开启全屏查看功能，默认为false
 * @param {boolean} zoom 是否开启图片放大功能，默认为false
 * @param {string} ratio 图片占屏幕比例，默认为1
 * @param {string} max-width 图片最大宽度，默认为3840
 * @param {boolean} preload 图片加载方式（eager ｜ lazy），默认为lazy
 * 可继承所有图片所有属性
 */
class HxzImage extends HTMLElement {
  constructor() {
    super()
    this.render = false
  }
  connectedCallback() {
    if (this.render) return
    this.render = true
    this.url = this.getAttribute('src')
    this.preload = this.hasAttribute('preload') || false
    // 移除loading，由于最初加载时会白屏，所以放到css中设置动画，图片加载完后撤掉动画css
    // this.generateLoading()
    this.renderImg()
    if (this.hasAttribute('zoom')) {
      this.renderZoom()
    }
    if (this.hasAttribute('full-screen')) {
      this.addEventListener('click', () => {
        const fullscreenImage = document.createElement('fullscreen-image')
        fullscreenImage.setAttribute('src', this.url)
        document.body.appendChild(fullscreenImage)
      })
    }
    this.created = true
  }
  generateImg(ratio) {
    const dpi = ratio || Number(this.getAttribute('ratio') || 1)
    const maxWidth = Number(this.getAttribute('max-width')) || 3840
    const map = [
      '180',
      '360',
      '375',
      '540',
      '720',
      '900',
      '1080',
      '1296',
      '1512',
      '1728',
      '1944',
      '2160',
      '2376',
      '2592',
      '2808',
      '3024',
      '3840',
    ]
    let flag = false
    const srcset = map.reduce((acc, cur) => {
      if (cur > maxWidth) {
        if (flag) return acc
        flag = true
      }
      return `${acc} ${this.url}&width=${cur * dpi} ${cur}w,`
    }, '')
    if (srcset.endsWith(',')) {
      return srcset.slice(0, -1)
    }
    return srcset
  }
  renderImg() {
    const srcset = this.generateImg()
    const img = document.createElement('img')
    img.setAttribute('width', '100%')
    img.setAttribute('height', '100%')
    img.setAttribute('loading', this.preload == true ? 'eager' : 'lazy')
    img.setAttribute('srcset', srcset)
    img.classList = this.classList
    if (this.created) {
      this.removeChild(this.querySelector('img'))
    }
    this.appendChild(img)
    this.img = img
    img.classList.add('-w-full', '-h-full')
    img.onload = () => {
      if (this.loadingBox) {
        this.loadingBox.remove()
        this.loadingBox = null
      }
      this.style.background = 'none'
      this.style.animation = 'none'
    }
  }
  renderZoom() {
    const srcset = this.generateImg(this.getAttribute('zoom') || 2)
    const img = document.createElement('img')
    img.setAttribute('srcset', srcset)
    img.style.position = 'absolute'
    img.style.maxWidth = 'none'
    if (this.created) {
      this.removeChild(this.querySelector('.zoom'))
    }
    const zoom = this.generateZoom(img)
    this.appendChild(zoom)
  }
  generateZoom(zoomedImage) {
    const zoom = document.createElement('div')
    zoom.style.position = 'absolute'
    zoom.style.top = '0'
    zoom.style.left = '0'
    zoom.style.width = '150px'
    zoom.style.height = '150px'
    zoom.style.overflow = 'hidden'
    zoom.style.display = 'none'
    zoom.style.borderRadius = '50%'
    zoom.style.zIndex = 10
    zoom.className = 'zoom'
    zoom.style.pointerEvents = 'none'
    zoom.appendChild(zoomedImage)
    const handleMouseMove = event => {
      const rect = this.img.getBoundingClientRect()
      const x = event.clientX - rect.left
      const y = event.clientY - rect.top
      const w = rect.width
      const h = rect.height
      const bw = zoom.offsetWidth
      const bh = zoom.offsetHeight

      const zoomFactor = this.getAttribute('zoom') || 2 // 放大倍数
      const zoomX = (x / w) * zoomedImage.width - bw / 2
      const zoomY = (y / h) * zoomedImage.height - bh / 2

      zoom.style.display = 'block'
      zoom.style.top = `${y - bh / 2}px`
      zoom.style.left = `${x - bw / 2}px`

      zoomedImage.style.width = `${w * zoomFactor}px`
      zoomedImage.style.height = `${h * zoomFactor}px`
      zoomedImage.style.transform = `translate(${-zoomX}px, ${-zoomY}px)`
    }
    this.addEventListener('mouseenter', () => {
      this.style.cursor = 'none'
      this.addEventListener('mousemove', handleMouseMove)
    })

    this.addEventListener('mouseleave', () => {
      zoom.style.display = 'none'
      this.style.cursor = 'default'
      this.removeEventListener('mousemove', handleMouseMove)
    })
    return zoom
  }
  generateLoading() {
    const div = document.createElement('div')
    div.className = 'hxz-image-loading'
    this.appendChild(div)
    this.loadingBox = div
  }
  static get observedAttributes() {
    return ['src']
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'src' && this.created) {
      this.url = newValue
      this.renderImg()
      if (this.hasAttribute('zoom')) {
        this.renderZoom()
      }
    }
  }
}
customElements.define('hxz-image', HxzImage)

/**
 * @property {string} images 所有图片地址，以英文逗号分隔
 * @property {boolean} responsive 是否要响应式，默认为 false
 * @property {string} media 所有图片响应式地址，以数字开始，以英文 | 分割，按顺序写入对应图片地址，以英文 ; 区分不同的屏幕宽度
 * 比如说： 1080|https://picsum.photos/300/300?random=1,https://picsum.photos/300/300?random=2;1440|https://picsum.photos/300/300?random=1,https://picsum.photos/300/300?random=2
 * @property {string} duration 动画持续时间，默认1s
 */
class SliderShow extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
  }
  render() {
    const len = this.images.length
    const cnt = len >> 1
    const style = this.createStyle(cnt)
    this.cnt = cnt
    this.shadowRoot.appendChild(style)
    const container = this.createElement()
    this.init(container)
    this.shadowRoot.appendChild(container)
    this.slotAppend()
  }
  created() {
    const imageString = this.getAttribute('images') || ''
    if (!imageString) {
      throw new Error('请传入图片地址')
    }
    let repeat = 0
    this.images = imageString.split(',')
    if (this.images.length == 1) {
      console.warn('请传入多张图片')
      this.images = this.images.concat(this.images)
      repeat++
    }
    this.responsive = this.getAttribute('responsive') || false
    const mediaStr = this.getAttribute('media') || ''
    if (mediaStr) {
      this.mediaMap = this.parseMedia(mediaStr)
    }
    // 保证最后生成的图片节点超过5张
    if (this.images.length == 2) {
      this.images = this.images.concat(this.images)
      repeat++
    }
    if (this.mediaMap) {
      for (let i = 0; i < repeat; i++) {
        this.mediaMap = this.mediaMap.map(item => [
          item[0],
          item[1].concat(item[1]),
        ])
      }
    }
    this.duration = this.getAttribute('duration') || 1
    this.loading = false
    this.render()
  }
  connectedCallback() {
    this.created()
    const leftArrow = this.querySelector('[slot="leftArrow"]')
    if (leftArrow) {
      leftArrow.addEventListener('click', this.prev.bind(this))
    }
    const rightArrow = this.querySelector('[slot="rightArrow"]')
    if (rightArrow) {
      rightArrow.addEventListener('click', this.next.bind(this))
    }
    const dotLine = this.querySelector('[slot="dotLine"]')
    if (dotLine) {
      this.dots = dotLine.querySelectorAll('*[name="dot"]')
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', this.setShow.bind(this, index))
      })
      this.dots[0].classList.add('active')
    }
    this.bindToucheEvent()
  }
  createStyle(cnt) {
    const style = document.createElement('style')
    style.textContent = `
      .slider-show {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        z-index:0;
      }
      .slider-show img {
        width: 100%;
        height: 100%;
        transition: all ${this.duration}s;
        position: absolute;
        top: 0;
        left: 0;
        z-index: ${cnt + 2};
      }
    `
    for (let i = 1; i <= cnt; i++) {
      style.textContent += `
        .slider-show img[data-index='${0 - i}'] {
          transform: translateX(-${i * 100}%);
          z-index: ${cnt + 2 - i};
        }
        .slider-show img[data-index='${0 + i}'] {
          transform: translateX(${i * 100}%);
          z-index: ${cnt + 2 - i};
        }
      `
    }
    style.textContent += `
      .slider-show img[data-index='-other'] {
        transform: translateX(-${(cnt + 1) * 100}%);
        z-index: 1;
      }

      .slider-show img[data-index='other'] {
        transform: translateX(${(cnt + 1) * 100}%);
        z-index: 1;
      }
    `
    return style
  }
  slotAppend() {
    const leftSlot = document.createElement('slot')
    leftSlot.setAttribute('name', 'leftArrow')
    const rightSlot = document.createElement('slot')
    rightSlot.setAttribute('name', 'rightArrow')
    const dotLineSlot = document.createElement('slot')
    dotLineSlot.setAttribute('name', 'dotLine')
    this.shadowRoot.appendChild(leftSlot)
    this.shadowRoot.appendChild(rightSlot)
    this.shadowRoot.appendChild(dotLineSlot)
  }
  createElement() {
    const div = document.createElement('div')
    div.classList.add('slider-show')
    this.images.forEach((src, index) => {
      const picture = document.createElement('picture')
      let source = ''
      if (this.mediaMap) {
        this.mediaMap.forEach(([width, urls]) => {
          source += `<source media="(min-width: ${width}px)" srcset="${urls[index]}">`
        })
      }
      picture.innerHTML = source + `<img src="${src}" data-id="${index + 1}">`
      div.appendChild(picture)
    })
    return div
  }
  parseMedia(mediaStr) {
    const mediaMap = mediaStr.split(';').map(item => {
      const [width, urlStr] = item.split('|')
      const urls = urlStr.split(',')
      return [Number(width), urls]
    })
    return mediaMap
  }
  bindToucheEvent() {
    let isMove = false,
      startX = 0,
      distanceX = 0
    this.addEventListener(
      'touchstart',
      event => {
        startX = event.touches[0].clientX
      },
      { passive: true }
    )
    this.addEventListener(
      'touchmove',
      event => {
        isMove = true
        distanceX = event.touches[0].clientX - startX
      },
      { passive: true }
    )
    this.addEventListener(
      'touchend',
      () => {
        if (isMove && Math.abs(distanceX) > 50) {
          if (distanceX > 0) {
            this.prev()
          } else {
            this.next()
          }
        }
      },
      { passive: true }
    )
  }
  init(container) {
    let imgs = container.querySelectorAll('picture')
    const imgLen = imgs.length,
      len = 2 * imgs.length
    imgs.forEach(img => {
      const cloneImg = img.cloneNode(true)
      cloneImg.setAttribute('data-index', 'other')
      container.appendChild(cloneImg)
    })
    const indexArr = []
    for (let i = 0; i < len; i++) {
      indexArr[i] = i % imgLen
    }
    this.curShowIndex = 0
    this.indexArr = indexArr
    this.imgList = container.querySelectorAll('img')
    this.showIndex(this.curShowIndex)
  }
  showIndex(curIndex) {
    let len = this.imgList.length
    let preIndex = curIndex == 0 ? len - 1 : curIndex - 1
    let nextIndex = curIndex == len - 1 ? 0 : curIndex + 1
    this.imgList[curIndex].setAttribute('data-index', 0)
    let count = 1,
      loopIndex = [curIndex]
    while (loopIndex.indexOf(preIndex) == -1) {
      this.imgList[preIndex].setAttribute(
        'data-index',
        count > this.cnt ? '-other' : -count
      )
      this.imgList[nextIndex].setAttribute(
        'data-index',
        count > this.cnt ? 'other' : count
      )
      count++
      loopIndex.push(preIndex)
      loopIndex.push(nextIndex)
      preIndex = preIndex == 0 ? len - 1 : preIndex - 1
      nextIndex = nextIndex == len - 1 ? 0 : nextIndex + 1
    }
    this.changeDotStatus(curIndex)
    setTimeout(() => {
      this.loading = false
    }, this.duration * 500)
  }
  // 上一个
  prev() {
    if (this.loading) return
    this.loading = true
    let len = this.imgList.length
    let index = this.curShowIndex == 0 ? len - 1 : this.curShowIndex - 1
    this.showIndex(index)
    this.curShowIndex = index
  }
  // 下一个
  next() {
    if (this.loading) return
    this.loading = true
    let len = this.imgList.length
    let index = this.curShowIndex == len - 1 ? 0 : this.curShowIndex + 1
    this.showIndex(index)
    this.curShowIndex = index
  }
  // 滚动到指定位置
  setShow(index) {
    let imgLen = this.imgList.length / 2,
      len = this.imgList.length
    if (index == this.curShowIndex % imgLen) return
    if (this.loading) return
    this.loading = true
    let pre = this.curShowIndex == 0 ? len - 1 : this.curShowIndex - 1
    let next = this.curShowIndex == len - 1 ? 0 : this.curShowIndex + 1
    let nextIndex = index
    while (this.indexArr[pre] != index && this.indexArr[next] != index) {
      pre = pre == 0 ? len - 1 : pre - 1
      next = next == len - 1 ? 0 : next + 1
    }
    if (this.indexArr[pre] == index) {
      nextIndex = pre
    } else {
      nextIndex = next
    }

    this.showIndex(nextIndex)
    this.curShowIndex = nextIndex
  }
  changeDotStatus(index) {
    if (this.dots) {
      const realIndex = index % this.dots.length
      this.dots.forEach((dot, i) => {
        if (i == realIndex) {
          dot.classList.add('active')
        } else {
          dot.classList.remove('active')
        }
      })
    }
  }
}

customElements.define('hxz-slider-show', SliderShow)

/**
 * @description: 进入视口，向上移动的动画
 * @param {boolean} data-animation 是否开启动画，默认为false
 */
class UpElement extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.offset = 80
    this.dataAnimation = this.getAttribute('data-animation')
    if (this.dataAnimation == 'true') {
      this.shadowRoot.innerHTML = `
        <div class="box" style="position:relative">
          <div class="upElement" style="transform: translateY(${this.offset}px);transition:all 1.4s cubic-bezier(0.22, 0.87, 0.94, 0.95);opacity:0.6;">
            <slot></slot>
          </div>
        </div>
      `
      this.container = this.shadowRoot.querySelector('.upElement')
    } else {
      this.shadowRoot.innerHTML = `<slot></slot>`
    }
  }

  connectedCallback() {
    this.style.opacity = '1'
    if (this.dataAnimation == 'true') {
      // 监听滚动事件，检查元素是否进入视口
      const intersectionObserver = new IntersectionObserver(
        entries => {
          if (entries[0].intersectionRatio <= 0) return
          this.doAnimation()
          intersectionObserver.unobserve(this)
        },
        { rootMargin: `-${this.offset}px` }
      )
      intersectionObserver.observe(this)
    }
  }

  doAnimation() {
    this.container.style.transform = 'translateY(0px)'
    this.container.style.opacity = '1'
  }
}

// 定义自定义元素
customElements.define('up-element', UpElement)

class HxzSwiper extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
  }
  connectedCallback() {
    this.current = 0
    let directionMap = { 0: 'horizontal', 1: 'vertical' }
    this.direction =
      directionMap[this.getAttribute('direction')] || 'horizontal'
    this.generateContainer()
    this.makeSwiperItems()
    this.makeContainerStyle()
    this.bindToucheEvent()
  }
  generateContainer() {
    this.showNum = Number(this.getAttribute('show-num')) || 1
    const container = document.createElement('div')
    container.className = 'swiper'
    container.innerHTML = `
        <div class="swiper-container">
          <slot name="container"></slot>
        </div>
        <div class="slot">
          <slot></slot>
        </div>
    `
    const style = document.createElement('style')
    style.textContent = `
      .swiper {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .slot {
        display:none;
      }
    `
    this.shadowRoot.appendChild(style)
    this.shadowRoot.appendChild(container)
  }
  bindToucheEvent() {
    let isMove = false,
      start = 0,
      distance = 0
    this.addEventListener(
      'touchstart',
      event => {
        if (this.direction == 'horizontal') {
          start = event.touches[0].clientX
        } else {
          start = event.touches[0].clientY
        }
      },
      { passive: true }
    )
    this.addEventListener(
      'touchmove',
      event => {
        isMove = true
        if (this.direction == 'horizontal') {
          distance = event.touches[0].clientX - start
        } else {
          distance = event.touches[0].clientY - start
        }
      },
      { passive: true }
    )
    this.addEventListener(
      'touchend',
      () => {
        if (isMove && Math.abs(distance) > 50) {
          if (distance > 0) {
            this.prev()
          } else {
            this.next()
          }
        }
      },
      { passive: true }
    )
  }
  makeSwiperItems() {
    const slot = this.shadowRoot.querySelector('.slot slot')
    const items = slot.assignedElements()
    this.totalItems = items.length
    this.swiperNums = Math.ceil(this.totalItems / this.showNum)
    let count = 0
    const documentFragment = document.createDocumentFragment()
    for (let i = 0; i < this.swiperNums; i++) {
      const swiperItem = document.createElement('div')
      swiperItem.classList.add('swiper-item')
      swiperItem.setAttribute('slot', 'container')
      for (let j = 0; j < this.showNum && count < items.length; j++) {
        // let item = items[count].cloneNode(true)
        swiperItem.appendChild(items[count])
        count++
      }
      documentFragment.appendChild(swiperItem)
    }
    this.appendChild(documentFragment)
  }
  makeContainerStyle() {
    const style = document.createElement('style')
    const count = Math.ceil(this.totalItems / this.showNum)
    const gap = this.getAttribute('gap') || '0px'
    style.textContent = `
      .swiper-container {
        display:grid;
        ${
          this.direction == 'horizontal'
            ? 'grid-template-columns'
            : 'grid-template-rows'
        }: repeat(${count}, 100%);
        width: 100%;
        height: 100%;
        transition: transform 0.5s linear;
      }
      ::slotted(.swiper-item) {
        width: 100%;
        height: 100%;
        display: grid;
        ${
          this.direction == 'horizontal'
            ? 'grid-template-columns'
            : 'grid-template-rows'
        }: repeat(${this.showNum}, 1fr);
        gap: ${gap}
      }
    `
    this.shadowRoot.appendChild(style)
  }
  prev() {
    if (this.current > 0) {
      this.current--
    }
    this.transform(this.current)
  }
  next() {
    if (this.current < this.swiperNums - 1) {
      this.current++
    }
    this.transform(this.current)
  }
  transform(index) {
    const container = this.shadowRoot.querySelector('.swiper-container')
    container.style.transform = `translate${
      this.direction == 'horizontal' ? 'X' : 'Y'
    }(-${index * 100}%)`
    this.dispatchEvent(
      new CustomEvent('change', {
        detail: index,
        bubbles: false, // 允许冒泡
      })
    )
  }
}
customElements.define('hxz-swiper', HxzSwiper)

class HxzButton extends HTMLElement {
  constructor() {
    super()
    this.render = false
  }
  connectedCallback() {
    if (this.render) return
    this.render = true
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'loading' && newValue === 'true') {
      this.renderLoading()
    }
    if (name === 'loading' && newValue === 'false') {
      this.cancelLoading()
    }
  }
  static get observedAttributes() {
    return ['loading']
  }
  renderLoading() {
    const loading = document.createElement('div')
    loading.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path class="svg-path" d="M10.7319 16.778C10.8291 17.3917 10.4096 17.9754 9.78864 17.9954C8.51444 18.0363 7.24156 17.8061 6.05585 17.3149C4.52239 16.6797 3.19445 15.6329 2.21885 14.2901C1.24324 12.9473 0.657971 11.3608 0.527744 9.70613C0.397517 8.05145 0.727407 6.39298 1.48094 4.91409C2.23448 3.43519 3.3823 2.19348 4.79751 1.32624C6.21273 0.458995 7.8402 2.9673e-08 9.5 0C11.1598 -2.9673e-08 12.7873 0.458995 14.2025 1.32624C15.2968 1.99682 16.2312 2.89128 16.9471 3.94617C17.296 4.46028 17.0703 5.14275 16.5167 5.42482C15.9631 5.7069 15.2926 5.47939 14.9226 4.98026C14.4097 4.28843 13.7671 3.69827 13.0269 3.24468C11.9655 2.59425 10.7449 2.25 9.5 2.25C8.25515 2.25 7.03454 2.59425 5.97313 3.24468C4.91172 3.89511 4.05086 4.82639 3.48571 5.93556C2.92056 7.04473 2.67314 8.28859 2.77081 9.5296C2.86848 10.7706 3.30743 11.9604 4.03914 12.9676C4.77084 13.9747 5.76679 14.7598 6.91689 15.2362C7.71892 15.5684 8.57412 15.7414 9.43527 15.7497C10.0566 15.7557 10.6347 16.1644 10.7319 16.778Z"/>
    </svg>
    `
    loading.classList.add('hxz-button-loading')
    loading.addEventListener('click', e => {
      e.stopPropagation()
      e.preventDefault()
    })
    this.appendChild(loading)
    this.loadingEl = loading
  }
  cancelLoading() {
    if (this.loadingEl) {
      this.removeChild(this.loadingEl)
      this.loadingEl = null
    }
  }
}
customElements.define('hxz-button', HxzButton)

// 电脑端横向滚动功能按钮
class HxzScrollButton extends HTMLElement {
  constructor() {
    super()
    this.target = null
    this.x = 0
    this.distance = 0
    this.maxX = 0
  }
  connectedCallback() {
    this.init()
  }
  init() {
    this.target = this.querySelector('.scroll-target')
    if (this.target) {
      if (this.target.scrollWidth > this.target.clientWidth) {
        this.maxX = this.target.scrollWidth - this.target.clientWidth
        this.distance = this.target.clientWidth
        this.bindScrollEvent()
      } else {
        let rightBtn = this.querySelector('.right-btn')
        if (rightBtn) {
          rightBtn.classList.add('-hidden')
        }
        let leftBtn = this.querySelector('.left-btn')
        if (leftBtn) {
          leftBtn.classList.add('-hidden')
        }
      }
    }
  }
  bindScrollEvent() {
    let rightBtn = this.querySelector('.right-btn')
    if (rightBtn) {
      rightBtn.addEventListener('click', () => {
        this.scrollRight()
      })
    }
    let leftBtn = this.querySelector('.left-btn')
    if (leftBtn) {
      leftBtn.addEventListener('click', () => {
        this.scrollLeft()
      })
    }
  }
  scrollRight() {
    this.x += this.distance
    if (this.x > this.maxX) {
      this.x = this.maxX
    }
    this.target.scrollTo({
      top: 0,
      left: this.x,
      behavior: 'smooth',
    })
  }
  scrollLeft() {
    this.x -= this.distance
    if (this.x < 0) {
      this.x = 0
    }
    this.target.scrollTo({
      top: 0,
      left: this.x,
      behavior: 'smooth',
    })
  }
}

customElements.define('hxz-scroll-button', HxzScrollButton)

/**
 * @description: 全屏展示图片，展示图片默认大小或者根据屏幕大小自适应
 * @param {string} src 图片地址
 */
class FullscreenImage extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
  }
  connectedCallback() {
    this.render()
  }
  render() {
    // Create elements
    const wrapper = document.createElement('div')
    const overlay = document.createElement('div')
    const img = document.createElement('img')

    // Apply classes
    wrapper.classList.add('wrapper')
    overlay.classList.add('overlay')
    img.classList.add('image')

    // Set attributes
    console.log('src:', this.getAttribute('src'))
    img.src = this.getAttribute('src') || ''

    // Add event listener for overlay click
    overlay.addEventListener('click', () => {
      this.remove()
    })

    // Append elements
    wrapper.appendChild(overlay)
    wrapper.appendChild(img)
    this.shadowRoot.append(wrapper)

    // Apply styles
    const style = document.createElement('style')
    style.textContent = `
        .wrapper {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, 0.5);
            z-index: 9999;
        }
        .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: -1;
            cursor: pointer;
        }
        .image {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    `
    this.shadowRoot.append(style)
  }
}

// Define the new element
customElements.define('fullscreen-image', FullscreenImage)
